import request from '@/utils/request'
//获取列表
export function getList(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/DeptDes/list',
        method: 'get',
        params:data
    })
}

//获取我的地图列表
export function UserMapList(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/UserMap/list',
        method: 'get',
        params:data
    })
}

//新增我的地图
export function addUserMap(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/UserMap/Add',
        method: 'post',
        data
    })
}

//删除我的地图
export function delUserMap(data) {
    return request({
        baseURL:process.env.VUE_APP_Dzy,
       url:'/api/UserMap/Delete',
        method: 'post',
        params:data
    })
}

//获取群组列表
export function TeamUserList(data) {
    return request({
        baseURL:process.env.VUE_APP_Dzy,
        url: '/api/TeamUser/List',
        method: 'get',
        params:data
    })
}
//新增群组
export function addTeamUser(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/TeamUser/Add',
        method: 'post',
        data
    })
}
//删除群组
export function delTeamUser(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '​/api​/TeamUser/Delete',
        method: 'post',
        params:data
    })
}

//获取群组列表
export function TagList(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Tag/list',
        method: 'get',
        params:data
    })
}

//新增
export function addTag(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Tag/Add',
        method: 'post',
        data
    })
}
//编辑
export function editTag(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Tag/Edit',
        method: 'post',
        data
    })
}
//删除
export function delTag(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Tag/Delete',
        method: 'post',
        params:data
    })
}

//删除群组用户
export function delTeamUserByMap(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/TeamUser/DelTeamUser',
        method: 'post',
        data
    })
}

//获取用户列表
export function getuserlist(data)
{
  return request({
    baseURL: process.env.VUE_APP_Dzy,
    url: '/api/TeamUser/GetUserList',
    method: 'get',
    params:data
  });
}

//获取群组用户列表
export function getUserListByMapID(data)
{
  return request({
    baseURL: process.env.VUE_APP_Dzy,
    url: '/api/TeamUser/GetUserListByMapID',
    method: 'get',
    params:data
  });
}



// WEBPACK FOOTER //
// ./src/utils/map/mapapi.js